import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import React, { useState, useRef, useEffect } from "react";

import { Box, Grid, Typography } from "@mui/material";
import { fonts, themes } from "../../themes/themes";

interface PropsValue {
  title: any;
  menu?: any;
  onSelect?: (data: any) => void;
  onAction?: any;
}

const styles: any = {
  btn_bg: {
    backgroundColor: "white",
    color: themes.greyDefault_500,
    padding: "5px",
    alignSelf: "center",
    textAlign: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  btn_bg_hover: {
    backgroundColor: themes.greyModalTitle,
    color: themes.greyDefault_500,
    padding: "5px",
    alignSelf: "center",
    textAlign: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
};
const TakeActionSplitBtn: React.FC<PropsValue> = ({
  menu,
  onSelect,
  title,
  onAction,
}) => {
  const [open, setOpen] = useState(false);
  const [boxWidth, setBoxWidth] = useState(0);
  const [boxHeight, setBoxHeight] = useState(0);

  const boxRef = useRef<HTMLDivElement>(null);

  const handleToggle = (m: any) => {
    setOpen(!open);
  };

  useEffect(() => {
    if (boxRef.current) {
      setBoxWidth(boxRef.current.offsetWidth);
      setBoxHeight(boxRef.current.offsetHeight);
    }
  }, [open]);

  return (
    // <>
    //   {open && (
    //     <Box
    //       style={{
    //         marginTop: "-145px",
    //         position: "absolute",
    //         height: "100px",
    //         width: `${boxWidth}px`,
    //         backgroundColor: "white", // Change "Red" to "red"
    //         zIndex: "9999",
    //       }}
    //     >
    //       <Typography
    //         onClick={handleToggle}
    //         style={{
    //           backgroundColor: "#E8FBF6",
    //           color: "#21D8A5",
    //           padding: "5px",
    //           alignSelf: "center",
    //           textAlign: "center",
    //           borderRadius: "5px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         Approved
    //       </Typography>
    //       <Typography
    //         onClick={handleToggle}
    //         style={{
    //           backgroundColor: "#FEF9EE",
    //           color: "#F4BE5E",
    //           padding: "5px",
    //           alignSelf: "center",
    //           textAlign: "center",
    //           borderRadius: "5px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         Hold
    //       </Typography>
    //       <Typography
    //         onClick={handleToggle}
    //         style={{
    //           backgroundColor: "#FFEDEF",
    //           color: "#FF5263",
    //           padding: "5px",
    //           alignSelf: "center",
    //           textAlign: "center",
    //           borderRadius: "5px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         Reject
    //       </Typography>
    //       <Typography
    //         onClick={handleToggle}
    //         style={{
    //           backgroundColor: "#F2E6F0",
    //           color: themes.primaryMain,
    //           padding: "5px",
    //           alignSelf: "center",
    //           textAlign: "center",
    //           borderRadius: "5px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         Escalation
    //       </Typography>
    //     </Box>
    //   )}
    //   <Grid ref={boxRef}>
    //     <ButtonGroup
    //       aria-label="split button"
    //       style={{
    //         backgroundColor: "#F5F5FA",
    //         borderRadius: "8px",
    //         height: "auto",
    //         width: "100%",
    //         position: "relative", // Add this line to make the parent container relative
    //       }}
    //     >
    //       <Button
    //         style={{
    //           backgroundColor: "#7C0E6F",
    //           height: "35px",
    //           borderRadius: "0.25em",
    //           color: "white",
    //           textTransform: "capitalize",
    //           fontFamily: fonts.fontFamily,
    //           borderColor: "#7C0E6F",
    //           minWidth: 50,
    //           width: "100%",
    //           zIndex: "999",
    //         }}
    //       >
    //         {title}
    //       </Button>
    //       <Button
    //         style={{
    //           backgroundColor: "#7C0E6F",
    //           color: "white",
    //           borderColor: "#7C0E6F",
    //           borderLeftColor: "GrayText",
    //           borderLeftWidth: "0.5px",
    //           zIndex: "999",
    //         }}
    //         size="small"
    //         aria-controls={open ? "split-button-menu" : undefined}
    //         aria-expanded={open ? "true" : undefined}
    //         aria-haspopup="menu"
    //         onClick={handleToggle}
    //       >
    //         <i className="las la-angle-down" />
    //       </Button>
    //     </ButtonGroup>
    //   </Grid>
    // </>
    <>
      {open && (
        <Box
          style={{
            marginTop: `-${boxHeight * 2}px`,
            position: "absolute",
            height: `${boxHeight}px`,
            width: `${boxWidth}px`,
            backgroundColor: "white", // Change "Red" to "red"
            zIndex: "9999",
          }}
        >
          {menu?.map((m: any) => {
            return (
              <Typography
                key={m?.id}
                onClick={() => onAction(m?.trigger)}
                style={{
                  backgroundColor: "white",
                  color: themes.greyDefault_500,
                  padding: "5px",
                  alignSelf: "center",
                  textAlign: "center",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                {m?.trigger_display_name}
              </Typography>
            );
          })}
        </Box>
      )}
      <Grid ref={boxRef}>
        <ButtonGroup
          aria-label="split button"
          style={{
            backgroundColor: "#F5F5FA",
            borderRadius: "8px",
            height: "auto",
            width: "100%",
            position: "relative", // Add this line to make the parent container relative
          }}
        >
          <Button
            style={{
              backgroundColor: "#7C0E6F",
              height: "35px",
              borderRadius: "0.25em",
              color: "white",
              textTransform: "capitalize",
              fontFamily: fonts.fontFamily,
              borderColor: "#7C0E6F",
              minWidth: 50,
              width: "100%",
              zIndex: "999",
            }}
          >
            {title}
          </Button>
          <Button
            style={{
              backgroundColor: "#7C0E6F",
              color: "white",
              borderColor: "#7C0E6F",
              borderLeftColor: "GrayText",
              borderLeftWidth: "0.5px",
              zIndex: "999",
            }}
            size="small"
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <i className="las la-angle-down" />
          </Button>
        </ButtonGroup>
      </Grid>
    </>
  );
};

export default TakeActionSplitBtn;
